import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import pic112 from '../assets/images/portsmouth-banner.jpg'

const MPsForPortsmouth = (props) => (
    <div>
        <Helmet>
            <title>Portsmouth MPs | Local Representatives | UK</title>
            <meta name="description" content="The constituency of Portsmouth was first represented by MPs all the way back
            in the 13th century although from that time all the way up to the early 20th century it was only a single 
            constituency and not the two constituencies that it is today." />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>MPs For Portsmouth</h1>
                    </header>
                    <span className="image main"><img src={pic112} alt="" /></span>
                    <p><b>Since the focus of this website is entirely on Portsmouth and our local MPs and representatives, 
                    I think it’s pretty important to keep you up to date with who our local MPs are.</b></p>
                    <p>Whether you’re living in the Portsmouth South constituency (i.e. any of the following wards – St Judes & St Thomas, Milton, 
                    Fratton, Eastney & Craneswater, Charles Dickens or Central Southsea) or Portsmouth North 
                    (i.e. any of the following wards- Baffins, Cosham, Copnor, Hilsea, Drayton & Farlington, or Nelson & Paulsgrove) you may not be aware of who your 
                    local MPs are, so here’s your guide to the people who are currently representing you in parliament!</p>
                    <p>Before we take a look at the people who are currently representing our interests in the House of Commons, let’s take a look at the history of MPs in our region.</p>
                
                    <hr/>

                    <h2>History of Portsmouth MP's</h2>
                    <p>The constituency of Portsmouth was first represented by MPs all the way back in the 13th century although from that time all the way up to the early 20th century it was only a single constituency and not the two constituencies that it is today. The very first MPs to be elected for Portsmouth North and South constituencies were chosen by the people back in 1918 – a century ago! Although there was a third constituency – Portsmouth Central – it went out of use in 1950. </p>
                
                    <p>Of special note among our former MPs include Mike Hancock MP (no relation to me, honest!) who represented Portsmouth South on no less than three separate occasions, once from 1984-1987 for the SDP, again between 1997 and 2013 for the Liberal Democrats and yet again from 2013 – 2015 as an independent candidate. </p>
                    <p>The 2017 General Election saw representatives for UKIP and the Green Party as well as the three other major parties, although it was Labour who won for Portsmouth South and Conservative who won for Portsmouth North on this occasion. </p>
                        
                    <hr/>

                    <h3>Stephen Morgan, Portsmouth North</h3>
                    <p>Representing the Labour Party, Stephen Morgan is MP for the Portsmouth South constituency. Having taken his seat with a swing of 21.5% (one of the biggest nationwide) during the General Election of 2017, he is currently acting as Private Parliamentary Secretary for our Shadow Secretary of State for Communities & Local Government. Stephen also currently sits on our Public Accounts Committee.</p>
                    
                    <hr/>
                    <h3>Penny Mordaunt, Portsmouth North</h3>

                    <p>Representing the Conservative Party, Penny Mordaunt represents the Portsmouth North constituency. She is one of the patrons of Enable Ability and the Victoria Cross Trust and she is also one of the Trustees of the Wymering Manor Trust as well as one of Portsmouth’s Scouting Ambassadors.</p>
                    <p>Appointed in 2015 to the role of Minister for Armed Forces, Penny is delighted to have been the first ever female MP to hold such a position. A year later, in 2016, she was given the role of Minister of State for Disabled People, Health & Work and then one year later, she changed roles, having been appointed to the role of Secretary of State for International Development. </p>
                    <a href="/#news" className="button">BACK HOME</a>
                </div>
            </section>
        </div>

    </div>
)

export default MPsForPortsmouth


// WEBPACK FOOTER //
// ./src/pages/mps-for-portsmouth.js